import { animations as voucherListAnimations } from '@app/vouchers/voucher-list/voucher-list.animations';

export const animations = voucherListAnimations;



// WEBPACK FOOTER //
// ./src/app/shared/coupons-list/coupons-list.animations.ts